// The formats a display's MAC address and serial number come in. Mirrors the API's
// api/service/src/modules/displays/deviceIdentifiers.ts, which applies the same check before it
// searches.

// Six hex octets separated by ':' or '-', e.g. 79:44:ce:51:bf:ae.
const MAC_ADDRESS_REGEX = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;

// 8-24 characters: letters, digits, dots, hyphens and underscores.
const SERIAL_NUMBER_REGEX = /^[a-zA-Z0-9._-]{8,24}$/;

export function isMacAddressOrSerialNumber(value: string): boolean {
  return MAC_ADDRESS_REGEX.test(value) || SERIAL_NUMBER_REGEX.test(value);
}
